import { Navigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { LoadingSpinner } from '../common/LoadingSpinner';

export const AdminRoute = ({ children }) => {
  const { userData, loading } = useUser();

  if (loading) {
    return <LoadingSpinner message="Checking permissions..." />;
  }

  if (!userData?.isAdmin) {
    return <Navigate to="/tasks" replace />;
  }

  return children;
};
